var _metadata, _sodipodiNamedview, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    width: 31,
    height: 29,
    viewBox: "0 0 31 29",
    fill: "none",
    id: "svg15",
    sodipodiDocname: "DefaultIcon.svg",
    inkscapeVersion: "0.92.3 (2405546, 2018-03-11)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata19"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }))))), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    objecttolerance: 10,
    gridtolerance: 10,
    guidetolerance: 10,
    inkscapePageopacity: 0,
    inkscapePageshadow: 2,
    "inkscapeWindow-width": 1920,
    "inkscapeWindow-height": 1017,
    id: "namedview17",
    showgrid: "false",
    inkscapeZoom: 8.137931,
    inkscapeCx: 15.5,
    inkscapeCy: 14.5,
    "inkscapeWindow-x": 0,
    "inkscapeWindow-y": 30,
    "inkscapeWindow-maximized": 1,
    "inkscapeCurrent-layer": "svg15"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.236 28.8705L9.66876 6.5957L0 28.9995H30.7061L24.9866 15.747L19.236 28.8705Z",
    fill: "url(#paint0_linear)",
    id: "path2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.5152 12.3398L19.2377 22.2295L11.0798 3.32533L12.5149 0L19.2366 15.5719L22.0786 9.01076L23.5152 12.3398Z",
    fill: "#BFBFBF",
    id: "path4",
    style: {
      fill: "#ffffff"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs13"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0.0000364401,
    y1: 17.7978,
    x2: 30.7061,
    y2: 17.7978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2531D",
    id: "stop6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999384,
    stopColor: "#FBC03D",
    id: "stop8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC03D",
    id: "stop10"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultIcon);
export default __webpack_public_path__ + "static/media/DefaultIcon.849c6bfff210edf6260809ee145bf41e.svg";
export { ForwardRef as ReactComponent };